import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const routeTitles = {
  '/': 'Libra Events & Decorators | Best Wedding Hall in Manjalpur Vadodara',
  '/AboutUs': 'About us | Best Wedding & Event Planners in Vadodara ',
  '/gallery': 'Gallery | Best Wedding & Event Planners in Vadodara',
  '/events': 'Events | Best Wedding & Event Planners in Vadodara',
  '/contactus': 'Contact Us | Best Wedding & Event Planners in Vadodara',
  '/venues': 'Venues | Best Wedding & Event Planners in Vadodara',
  '/LibraBanquetHall': 'Libra Banquet Hall | Venue Details',
  '/EvaBanquetHall': 'Eva Banquet Hall | Venue Details',
  '/KBPatelPARTYPLOT': 'KB Patel PARTY PLOT | Venue Details',
  '/EvaBanquet':'Eva Banquet | Best Wedding & Event Planners in Vadodara',
  '/blog':'Blog | Best Wedding & Event Planners in Vadodara'
};

const PageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;
    document.title = routeTitles[currentPath] || 'Libra Events';
  }, [location.pathname]);

  return null; // No UI to render
};

export default PageTitle;
